import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';

@Mixin
class WithSpinner extends Vue {
    protected spinner: any = {
        minimumTimeToShow: 500,
        show: false,
        hideRequested: false,
        lastTimeShowWasRequested: -1,
    };

    protected changeSpinnerVisibility( visibility: boolean ) {
        this.spinner[ 'hideRequested' ] = !visibility;
        this.spinner[ 'show' ] = visibility;
    }

    protected requestShowSpinner() {
        this.spinner[ 'lastTimeShowWasRequested' ] = new Date().getTime();
        this.spinner[ 'hideRequested' ] = false;
    }

    protected spinner2: any = {
        minimumTimeToShow: 500,
        show: false,
        hideRequested: false,
        lastTimeShowWasRequested: -1,
    };

    protected changeSpinnerVisibility2( visibility: boolean ) {
        this.spinner2[ 'hideRequested' ] = !visibility;
        this.spinner2[ 'show' ] = visibility;
    }

    protected requestShowSpinner2() {
        this.spinner2[ 'lastTimeShowWasRequested' ] = new Date().getTime();
        this.spinner2[ 'hideRequested' ] = false;
    }
}

export default WithSpinner;
